import { formatRelativeTime } from '@/lib/utils';
import EyeIcon from '@/assets/common/eye.svg?react';
import MessageIcon from '@/assets/common/message-circle.svg?react';
import ClockIcon from '@/assets/common/clock.svg?react';
import CalendarIcon from '@/assets/common/calendar.svg?react';
import styles from './ArticleMeta.module.scss';
import type { Article } from '@/types/article';

interface ArticleMetaProps {
  article: Article;
  showAuthor?: boolean;
}

export function ArticleMeta({ article, showAuthor = false }: ArticleMetaProps) {
  return (
    <div className={styles.meta}>
      {showAuthor && article.author && (
        <div className={styles.meta__author}>
          <span className={styles.meta__authorName}>
            {article.author.display_name || article.author.email}
          </span>
        </div>
      )}

      <div className={styles.meta__stats}>
        <span className={styles.meta__item}>
          <ClockIcon className={styles.meta__icon} />
          {article.time_to_read_minutes} min read
        </span>

        <span className={styles.meta__item}>
          <EyeIcon className={styles.meta__icon} />
          {article.view_count} views
        </span>

        <span className={styles.meta__item}>
          <MessageIcon className={styles.meta__icon} />
          {article.comment_count} comments
        </span>

        <span className={styles.meta__item}>
          <CalendarIcon className={styles.meta__icon} />
          {article.published_at
            ? formatRelativeTime(article.published_at)
            : formatRelativeTime(article.created_at)}
        </span>
      </div>

      <div className={styles.meta__badges}>
        {article.topic && (
          <span className={styles.meta__topic}>{article.topic}</span>
        )}

        {article.tags && article.tags.length > 0 && (
          <div className={styles.meta__tags}>
            {article.tags.map((tag) => (
              <span key={tag} className={styles.meta__tag}>
                {tag}
              </span>
            ))}
          </div>
        )}

        <span className={`${styles.meta__visibility} ${article.is_public ? styles['meta__visibility--public'] : ''}`}>
          {article.is_public ? '🌐 Public' : '🔒 Private'}
        </span>
      </div>
    </div>
  );
}
